// Module
var code = "<div class=\"unsubscribe-button o2d\"><div class=\"btn btn-danger\" ng-if=\"!vm.unsubscribed\" ng-click=\"vm.unsubscribe()\" loading-when=\"vm.unsubscribing\">Unsubscribe</div><span ng-if=\"vm.unsubscribed\">Unsubscribed</span></div>";
// Exports
var _module_exports =code;;
var path = 'app/views/visits/list/tabs/rx-hub/components/unsubscribe-o2d/unsubscribe-o2d-button.component.html';
var angular = require('angular');
angular.module('pims').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
export default path;